module.exports = __webpack_public_path__ + "static/media/LOGO_new.3e29a23e.svg";